// Plan type enum matching backend
export enum PlanType {
  Starter = 0,
  Professional = 1
}

// Current user's plan usage statistics
export interface PlanUsage {
  currentPlan: PlanType;
  planName: string;
  clientsCount: number;
  clientsLimit: number;
  invoicesThisMonth: number;
  invoicesLimit: number;
  invoicesResetDate: Date;
  canCreateClient: boolean;
  canCreateInvoice: boolean;
}

// Plan limits configuration
export interface PlanLimits {
  maxClients: number;
  maxInvoicesPerMonth: number;
  canAccessReports: boolean;
  canExportData: boolean;
  canUseTimeTracking: boolean;
}

// Individual plan feature
export interface PlanFeature {
  text: string;
  included: boolean;
}

// Plan information for pricing page
export interface PlanInfo {
  planType: PlanType;
  name: string;
  description: string;
  price: number;
  priceLabel: string;
  limits: PlanLimits;
  features: PlanFeature[];
  isPopular: boolean;
}

// Plan limit error response from API
export interface PlanLimitError {
  code: string;
  message: string;
  limitType: string;
  currentCount: number;
  maxAllowed: number;
  currentPlan: PlanType;
  upgradeUrl: string;
}

// Stripe subscription status
export interface SubscriptionStatus {
  planType: string;
  isActive: boolean;
  status: string;
  currentPeriodEnd: Date | null;
  hasStripeCustomer: boolean;
}

// Payment method type
export type PaymentMethod = 'stripe' | 'paypal';
